(function () {
      'use strict';

      var tabsRoot = document.querySelector('.ugc-tabs');
      if (!tabsRoot) return;

      function wrapAmpersands(root) {
        if (!root) return;
        var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
        var textNodes = [];
        while (walker.nextNode()) textNodes.push(walker.currentNode);
        textNodes.forEach(function (node) {
          if (!node.nodeValue || node.nodeValue.indexOf('&') === -1) return;
          var parent = node.parentElement;
          if (!parent || parent.classList.contains('ugc-amp')) return;
          if (parent.tagName === 'SCRIPT' || parent.tagName === 'STYLE') return;
          var parts = node.nodeValue.split('&');
          if (parts.length <= 1) return;
          var frag = document.createDocumentFragment();
          parts.forEach(function (part, i) {
            if (part) frag.appendChild(document.createTextNode(part));
            if (i < parts.length - 1) {
              var span = document.createElement('span');
              span.className = 'ugc-amp';
              span.textContent = '&';
              frag.appendChild(span);
            }
          });
          node.parentNode.replaceChild(frag, node);
        });
      }

      wrapAmpersands(tabsRoot);

      var parent = tabsRoot.parentElement;
      while (parent && parent !== document.documentElement) {
        if (
          parent.classList.contains('shopify-section') ||
          (parent.id && parent.id.indexOf('shopify-section') === 0) ||
          String(parent.className).indexOf('padding') !== -1 ||
          String(parent.className).indexOf('page-width') !== -1
        ) {
          parent.style.setProperty('padding-top', '0', 'important');
          parent.style.setProperty('padding-bottom', '0', 'important');
          parent.style.setProperty('margin-top', '0', 'important');
          parent.style.setProperty('margin-bottom', '0', 'important');
        }
        if (
          parent.id === 'PageContainer' ||
          String(parent.className).indexOf('page-container') !== -1
        ) {
          parent.style.setProperty('overflow', 'visible', 'important');
        }
        parent = parent.parentElement;
      }

      /* ===== Sticky nav：PC 用 CSS sticky，移动端 JS 动态 top ===== */
      var navWrap = tabsRoot.querySelector('.ugc-tabs__nav-wrap');
      var getNavStickyTop = function () { return 0; };
      var mqMobile = window.matchMedia('(max-width: 1023px)');

      if (navWrap) {
        var placeholder = document.createElement('div');
        placeholder.className = 'ugc-tabs__nav-placeholder';
        placeholder.setAttribute('aria-hidden', 'true');
        navWrap.insertAdjacentElement('afterend', placeholder);

        var navAnchorY = 0;

        function isMobileSticky() {
          return mqMobile.matches;
        }

        function clearFixedNav() {
          navWrap.classList.remove('is-fixed');
          navWrap.style.removeProperty('top');
          navWrap.style.removeProperty('left');
          navWrap.style.removeProperty('right');
          navWrap.style.removeProperty('width');
          placeholder.style.display = 'none';
        }

        function readNavAnchorY() {
          clearFixedNav();
          navAnchorY = navWrap.getBoundingClientRect().top + window.pageYOffset;
        }

        function measureHeaderBottom() {
          var bottom = 0;
          var seen = new Set();
          var nodes = document.querySelectorAll(
            '[id*="announcement-bar"], .shopify-section-group-header-group, .site-header, header.site-header'
          );
          for (var i = 0; i < nodes.length; i++) {
            var el = nodes[i];
            if (seen.has(el)) continue;
            seen.add(el);
            var rect = el.getBoundingClientRect();
            if (rect.bottom > 0 && rect.top < 160) {
              bottom = Math.max(bottom, rect.bottom);
            }
          }
          return Math.max(0, Math.round(bottom));
        }

        function updateStickyNav() {
          if (!isMobileSticky()) {
            clearFixedNav();
            return;
          }

          var navH = navWrap.offsetHeight;
          var scrollY = window.pageYOffset;
          var tabsTop = tabsRoot.getBoundingClientRect().top + scrollY;
          var tabsBottom = tabsTop + tabsRoot.offsetHeight;
          var offset = measureHeaderBottom();
          var shouldFix = scrollY + offset >= navAnchorY && scrollY + offset + navH < tabsBottom;

          if (shouldFix) {
            navWrap.classList.add('is-fixed');
            placeholder.style.display = 'block';
            placeholder.style.height = navH + 'px';
            navWrap.style.top = offset + 'px';
          } else {
            clearFixedNav();
          }
        }

        getNavStickyTop = function () {
          return navWrap.classList.contains('is-fixed')
            ? (parseFloat(navWrap.style.top) || 0)
            : 0;
        };

        readNavAnchorY();
        window.addEventListener('scroll', updateStickyNav, { passive: true });
        window.addEventListener('resize', function () {
          readNavAnchorY();
          updateStickyNav();
        });
        if (mqMobile.addEventListener) {
          mqMobile.addEventListener('change', function () {
            readNavAnchorY();
            updateStickyNav();
          });
        }
        updateStickyNav();
      }

      /* ===== Tab switching ===== */
      var tabBtns = Array.prototype.slice.call(tabsRoot.querySelectorAll('.ugc-tabs__btn'));
      var tabPanels = Array.prototype.slice.call(tabsRoot.querySelectorAll('.ugc-tabs__panel'));
      var validTabs = tabBtns.map(function (btn) { return btn.getAttribute('data-tab'); });
      var activeTab = 'about';

      function setTabHash(tabId) {
        if (validTabs.indexOf(tabId) === -1) return;
        var nextHash = '#' + tabId;
        if (window.location.hash !== nextHash) {
          history.replaceState(null, '', nextHash);
        }
      }

      function getTabFromHash() {
        var hash = window.location.hash.replace(/^#/, '');
        return validTabs.indexOf(hash) !== -1 ? hash : null;
      }

      function switchTab(tabId, options) {
        options = options || {};
        if (!options.force && tabId === activeTab) return;
        activeTab = tabId;
        tabBtns.forEach(function (btn) {
          var on = btn.getAttribute('data-tab') === tabId;
          btn.classList.toggle('is-active', on);
          btn.setAttribute('aria-selected', on ? 'true' : 'false');
          btn.setAttribute('tabindex', on ? '0' : '-1');
        });
        tabPanels.forEach(function (panel) {
          var on = panel.getAttribute('data-panel') === tabId;
          panel.classList.toggle('is-active', on);
          if (on) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        });
        if (!options.fromHash) setTabHash(tabId);
        var navWrap = tabsRoot.querySelector('.ugc-tabs__nav-wrap');
        var navH = navWrap ? navWrap.offsetHeight : 0;
        var stickyTop = getNavStickyTop();
        var top = tabsRoot.getBoundingClientRect().top + window.pageYOffset;
        if (options.fromHash || window.pageYOffset > top - navH - stickyTop) {
          window.scrollTo({ top: top - navH - stickyTop, behavior: options.fromHash ? 'auto' : 'smooth' });
        }
      }

      function applyHashTab() {
        var tabId = getTabFromHash();
        if (tabId) switchTab(tabId, { fromHash: true, force: true });
      }

      tabBtns.forEach(function (btn) {
        btn.addEventListener('click', function () { switchTab(btn.getAttribute('data-tab')); });
        btn.addEventListener('keydown', function (e) {
          var i = tabBtns.indexOf(btn), next = -1;
          if (e.key === 'ArrowRight') next = (i + 1) % tabBtns.length;
          else if (e.key === 'ArrowLeft') next = (i - 1 + tabBtns.length) % tabBtns.length;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = tabBtns.length - 1;
          if (next >= 0) { e.preventDefault(); tabBtns[next].focus(); switchTab(tabBtns[next].getAttribute('data-tab')); }
        });
      });

      tabsRoot.querySelectorAll('[data-switch-tab]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          var tabId = el.getAttribute('data-switch-tab');
          var targetBtn = tabsRoot.querySelector('.ugc-tabs__btn[data-tab="' + tabId + '"]');
          if (targetBtn) targetBtn.focus();
          switchTab(tabId);
        });
      });

      window.addEventListener('hashchange', function () {
        var tabId = getTabFromHash();
        if (tabId) switchTab(tabId, { fromHash: true, force: true });
      });
      applyHashTab();

      /* ===== PC Tracks data & interaction ===== */
      var ICON_CAM = '📸';
      var ICON_WRENCH = '🔨';
      var ICON_VIDEO = '🎥';

      var TRACKS = [
        {
          name: 'Artistic Photography',
          icon: ICON_CAM,
          imgBefore: 'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/2_d598c503-9125-4aa1-96d0-df2c9a8db94d.png?v=1782976083',
          imgSmall: 'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/2_7437baec-21bf-41fa-9464-f9be1bd3bef9.png?v=1782976083',
          imgLarge: 'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/2_07dd927e-ba8f-4ea5-9391-7c96240434fd.png?v=1782976083',
          tagline: 'Show your finished project in its best light.',
          tips: [
            'Showcase a completed Muzata cable railing project',
            'Include multiple angles and perspectives',
            'Use high-quality photos or videos with clear visual details'
          ],
          mobImg: 'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/2_17dec42d-3d48-4796-a345-fd0f0c861527.png?v=1783059163',
          mobLead: 'Show your finished project in its best light.',
          mobTips: [
            'Showcase a completed Muzata project',
            'Capture multiple angles',
            'Use clear, high-quality photos or videos ≥15 seconds'
          ],
          glowColor: '#FFF4D6'
        },
        {
          name: 'Installation Journey',
          icon: ICON_WRENCH,
          imgBefore: 'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/2_3c1daba7-e459-4e96-9cb3-99f24fb06c31.png?v=1782976083',
          imgSmall: 'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/2_49d19be7-d8ba-41c5-85d9-d51d544ff0e5.png?v=1782976083',
          imgLarge: 'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/2_25583e20-6cd0-4bdb-912b-0c8a76b78645.png?v=1782976083',
          tagline: 'Capture your DIY process with Muzata.',
          tips: [
            'Show process for installation, or before & after results',
            'Tell the story behind your Muzata brand',
            'Provide DIY videos and helpful solutions for installation, which are especially recommended'
          ],
          mobImg: 'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/2_35b75c12-6199-420f-9df6-250b1604634b.png?v=1783059163',
          mobLead: 'Capture your DIY process with Muzata',
          mobTips: [
            'Show installation or before & after',
            'Tell your project story',
            'Use clear, high-quality photos or videos ≥15 seconds'
          ],
          glowColor: '#BEEBFF'
        },
        {
          name: 'Creative Video',
          icon: ICON_VIDEO,
          imgBefore: 'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/2_af90e3d3-ee2c-4bce-8859-eb27611ca4e1.png?v=1782976083',
          imgLarge: 'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/2_3af4b555-4930-4e15-bd08-03a8074362f7.png?v=1782976083',
          imgSmall: 'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/2_c04c111a-7358-49c7-b7e3-4e21984d8f77.png?v=1782976083',
          tagline: 'Bring your project to life through your creativity.',
          tips: [
            'Show your Muzata railing story from pro use, styling, or decoration aspect',
            'Refinement: record the build process or project transformation',
            'Video styling only — artistic/lifestyle/cinematic style is also encouraged'
          ],
          mobImg: 'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/2_e6664b18-3ec7-440b-8800-f62e44fa509b.png?v=1783059163',
          mobLead: 'Bring your project to life through your creativity.',
          mobTips: [
            'Share your creative railing decoration or usage',
            'Show DIY or transformations',
            'Video only (≥15 seconds) • Family & Friends welcome'
          ],
          glowColor: '#FFE8C8'
        }
      ];

      function trackImg(track, size) {
        if (size === 'large') return track.imgLarge;
        if (size === 'small') return track.imgSmall;
        if (size === 'mobile') return track.mobImg;
        return track.imgBefore;
      }

      var tracksPc = tabsRoot.querySelector('[data-tracks-pc]');
      if (tracksPc) {
        var grid = tracksPc.querySelector('[data-tracks-grid]');
        var hero = tracksPc.querySelector('[data-tracks-hero]');
        var heroImg = tracksPc.querySelector('[data-tracks-hero-img]');
        var heroHead = tracksPc.querySelector('[data-tracks-hero-head]');
        var heroTagline = tracksPc.querySelector('[data-tracks-hero-tagline]');
        var heroList = tracksPc.querySelector('[data-tracks-hero-list]');
        var heroClose = tracksPc.querySelector('[data-tracks-hero-close]');
        var activeIdx = 0;
        var expanded = false;

        function collapseTracks() {
          expanded = false;
          tracksPc.classList.remove('is-expanded');
          tracksPc.classList.add('is-collapsed');
          hero.setAttribute('aria-hidden', 'true');
          renderGrid();
        }

        function renderGrid() {
          grid.innerHTML = '';
          TRACKS.forEach(function (track, i) {
            if (expanded && i === activeIdx) return;
            var imgSrc = expanded ? trackImg(track, 'small') : trackImg(track, 'before');
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'ugc-track' + (i === activeIdx && expanded ? ' is-active' : '');
            btn.setAttribute('data-track-index', String(i));
            btn.setAttribute('aria-label', 'View ' + track.name);
            btn.innerHTML =
              '<span class="ugc-track__media"><img src="' + imgSrc + '" alt=""></span>' +
              '<span class="ugc-track__badge">' + track.icon + ' ' + track.name + '</span>' +
              '<span class="ugc-track__plus" aria-hidden="true">+</span>';
            btn.addEventListener('click', function () {
              activeIdx = i;
              expanded = true;
              tracksPc.classList.remove('is-collapsed');
              tracksPc.classList.add('is-expanded');
              tracksPc.setAttribute('data-active', String(i));
              updateHero();
              renderGrid();
            });
            grid.appendChild(btn);
          });
        }

        function updateHero() {
          var t = TRACKS[activeIdx];
          heroImg.src = trackImg(t, 'large');
          heroImg.alt = t.name;
          heroHead.innerHTML = t.icon + ' ' + t.name;
          heroTagline.textContent = t.tagline;
          heroList.innerHTML = t.tips.map(function (tip) { return '<li>' + tip + '</li>'; }).join('');
          hero.removeAttribute('aria-hidden');
        }

        renderGrid();

        if (heroClose) {
          heroClose.addEventListener('click', collapseTracks);
        }
      }

      /* ===== Mobile cards from TRACKS ===== */
      var mobScrollEl = tabsRoot.querySelector('[data-mob-scroll]');
      if (mobScrollEl) {
        TRACKS.forEach(function (track) {
          var tipsHtml = track.mobTips.map(function (tip) {
            return '<li>' + tip + '</li>';
          }).join('');
          var article = document.createElement('article');
          article.className = 'ugc-mob-card';
          article.innerHTML =
            '<svg class="ugc-mob-card__glow" viewBox="0 0 320 190" preserveAspectRatio="none" aria-hidden="true" focusable="false">' +
              '<ellipse cx="80" cy="175" rx="180" ry="75" fill="' + track.glowColor + '" opacity="0.4"></ellipse>' +
            '</svg>' +
            '<div class="ugc-mob-card__img-wrap">' +
              '<img class="ugc-mob-card__img" src="' + trackImg(track, 'mobile') + '" alt="' + track.name + '">' +
              '<span class="ugc-mob-card__badge">' + track.icon + ' ' + track.name + '</span>' +
            '</div>' +
            '<div class="ugc-mob-card__body">' +
              '<p class="ugc-mob-card__lead">' + track.mobLead + '</p>' +
              '<div class="ugc-mob-card__divider"></div>' +
              '<p class="ugc-mob-card__tips-title">Standout Tips</p>' +
              '<ul class="ugc-mob-card__list">' + tipsHtml + '</ul>' +
            '</div>';
          mobScrollEl.appendChild(article);
        });
      }

      /* ===== Mobile carousel dots ===== */
      var mobScroll = mobScrollEl;
      var mobDots = tabsRoot.querySelector('[data-mob-dots]');
      if (mobScroll && mobDots) {
        var dots = Array.prototype.slice.call(mobDots.querySelectorAll('.ugc-tracks-mob__dot'));
        var cards = Array.prototype.slice.call(mobScroll.children);

        function setDot(i) {
          dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
        }

        dots.forEach(function (dot, i) {
          dot.addEventListener('click', function () {
            cards[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
            setDot(i);
          });
        });

        mobScroll.addEventListener('scroll', function () {
          var center = mobScroll.scrollLeft + mobScroll.clientWidth / 2;
          var closest = 0, min = Infinity;
          cards.forEach(function (card, i) {
            var cardCenter = card.offsetLeft + card.offsetWidth / 2;
            var dist = Math.abs(center - cardCenter);
            if (dist < min) { min = dist; closest = i; }
          });
          setDot(closest);
        }, { passive: true });
      }

      /* ===== Past Highlights（媒体地址见 ugc-highlights-data.js · 完整 URL 无拼接） ===== */
      var HL_DATA = window.UGC_HIGHLIGHTS || {};
      var WATERFALL_ITEMS = HL_DATA.WATERFALL_ITEMS || [];
      var FEATURED_ITEMS = HL_DATA.FEATURED_ITEMS || [];

      function itemFullSrc(item) {
        return item.full || item.src || item.cover;
      }

      function itemThumbSrc(item) {
        return item.cover || item.srcPc || item.srcMob || item.src || item.full;
      }

      function isFeaturedPcLayout() {
        return window.matchMedia('(min-width: 1024px)').matches;
      }

      function featuredSpreadPx(isMob) {
        if (isMob) return 34;
        var w = window.innerWidth;
        if (w < 1200) return 30;
        if (w < 1280) return 36;
        if (w < 1440) return 42;
        return 50;
      }

      function featuredMaxRot(isMob) {
        if (isMob) return 4;
        return window.innerWidth < 1280 ? 3 : 4;
      }

      function featuredCardSrc(item) {
        return isFeaturedPcLayout() ? item.srcPc : item.srcMob;
      }

      function waterfallColumnLayout(total, cols) {
        var perCol = Math.ceil(total / cols);
        var columns = [];
        var c, r, idx;
        for (c = 0; c < cols; c++) {
          columns[c] = [];
          for (r = 0; r < perCol; r++) {
            idx = c * perCol + r;
            if (idx < total) columns[c].push(idx);
          }
        }
        /* PC 四列：第三列最后一张移到第四列开头 */
        if (cols === 4 && columns[2] && columns[2].length && columns[3]) {
          columns[3].unshift(columns[2].pop());
        }
        /* 移动两列：第二列第一张移到第一列最后 */
        if (cols === 2 && columns[1] && columns[1].length && columns[0]) {
          columns[0].push(columns[1].shift());
        }
        return columns;
      }

      function highlightsPanelActive() {
        var panel = tabsRoot.querySelector('[data-panel="highlights"]');
        return panel && panel.classList.contains('is-active');
      }

      var pauseWaterfallForLightbox = false;

      function createLightbox() {
        var root = document.createElement('div');
        root.className = 'ugc-lightbox';
        root.setAttribute('hidden', '');
        root.innerHTML =
          '<button type="button" class="ugc-lightbox__close" aria-label="Close">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><circle cx="24" cy="24" r="22" fill="#333333"/><path d="M15.5215 15.5078L32.492 32.4784" stroke="white" stroke-width="4" stroke-linecap="round"/><path d="M15.5078 32.4785L32.4784 15.508" stroke="white" stroke-width="4" stroke-linecap="round"/></svg>' +
          '</button>' +
          '<div class="ugc-lightbox__main">' +
            '<button type="button" class="ugc-lightbox__arrow ugc-lightbox__arrow--prev" aria-label="Previous">' +
              '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '</button>' +
            '<figure class="ugc-lightbox__figure">' +
              '<img src="" alt="">' +
              '<video class="ugc-lightbox__video" controls playsinline hidden></video>' +
              '<figcaption class="ugc-lightbox__badge" hidden></figcaption>' +
            '</figure>' +
            '<button type="button" class="ugc-lightbox__arrow ugc-lightbox__arrow--next" aria-label="Next">' +
              '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="ugc-lightbox__footer">' +
            '<div class="ugc-lightbox__dots" data-lightbox-dots></div>' +
            // '<div class="ugc-lightbox__thumbs" data-lightbox-thumbs></div>' +
          '</div>';

        document.body.appendChild(root);

        var imgEl = root.querySelector('.ugc-lightbox__figure img');
        var videoEl = root.querySelector('.ugc-lightbox__video');
        var badgeEl = root.querySelector('.ugc-lightbox__badge');
        var dotsEl = root.querySelector('[data-lightbox-dots]');
        // var thumbsEl = root.querySelector('[data-lightbox-thumbs]');
        var items = [];
        var index = 0;

        function renderMeta() {
          dotsEl.innerHTML = '';
          // thumbsEl.innerHTML = '';
          items.forEach(function (item, i) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'ugc-lightbox__dot' + (i === index ? ' is-active' : '');
            dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
            dot.addEventListener('click', function () { go(i); });
            dotsEl.appendChild(dot);

            var thumb = document.createElement('button');
            thumb.type = 'button';
            thumb.className = 'ugc-lightbox__thumb' + (i === index ? ' is-active' : '');
            thumb.innerHTML = '<img src="' + itemThumbSrc(item) + '" alt="">';
            thumb.addEventListener('click', function () { go(i); });
            // thumbsEl.appendChild(thumb);
          });
        }

        function syncMeta() {
          Array.prototype.forEach.call(dotsEl.children, function (dot, i) {
            dot.classList.toggle('is-active', i === index);
          });
          // Array.prototype.forEach.call(thumbsEl.children, function (thumb, i) {
          //   thumb.classList.toggle('is-active', i === index);
          // });
        }

        function showMedia(item) {
          var isVideo = item.type === 'video';
          if (isVideo) {
            imgEl.setAttribute('hidden', '');
            videoEl.removeAttribute('hidden');
            videoEl.src = itemFullSrc(item);
            videoEl.load();
            videoEl.play().catch(function () {});
          } else {
            videoEl.pause();
            videoEl.removeAttribute('src');
            videoEl.load();
            videoEl.setAttribute('hidden', '');
            imgEl.removeAttribute('hidden');
            imgEl.src = itemFullSrc(item);
          }
        }

        function go(i) {
          index = (i + items.length) % items.length;
          var item = items[index];
          showMedia(item);
          imgEl.alt = item.badge || item.caption || 'Past contest entry';
          if (item.badge) {
            badgeEl.textContent = item.badge;
            badgeEl.removeAttribute('hidden');
          } else {
            badgeEl.setAttribute('hidden', '');
          }
          syncMeta();
        }

        function close() {
          videoEl.pause();
          pauseWaterfallForLightbox = false;
          root.classList.remove('is-open');
          root.setAttribute('hidden', '');
          document.body.style.overflow = '';
        }

        function open(list, startIndex) {
          items = list;
          index = startIndex || 0;
          renderMeta();
          go(index);
          pauseWaterfallForLightbox = true;
          root.classList.add('is-open');
          root.removeAttribute('hidden');
          document.body.style.overflow = 'hidden';
        }

        root.querySelector('.ugc-lightbox__close').addEventListener('click', close);
        root.querySelector('.ugc-lightbox__arrow--prev').addEventListener('click', function () { go(index - 1); });
        root.querySelector('.ugc-lightbox__arrow--next').addEventListener('click', function () { go(index + 1); });
        root.addEventListener('click', function (e) {
          if (e.target === root) close();
        });
        document.addEventListener('keydown', function (e) {
          if (!root.classList.contains('is-open')) return;
          if (e.key === 'Escape') close();
          else if (e.key === 'ArrowLeft') go(index - 1);
          else if (e.key === 'ArrowRight') go(index + 1);
        });

        return { open: open, close: close };
      }

      var lightbox = createLightbox();

      function getColumnCount() {
        return window.innerWidth < 1024 ? 2 : 4;
      }

      function buildWaterfallItem(item, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ugc-waterfall__item';
        btn.setAttribute('data-index', String(i));
        var html = '<span class="ugc-waterfall__media"><img src="' + item.cover + '" alt="Past contest entry ' + item.id + '" loading="lazy"></span>';
        if (item.type === 'video') {
          html += '<span class="ugc-waterfall__play" aria-hidden="true"></span>';
        }
        btn.innerHTML = html;
        return btn;
      }

      function renderWaterfallGrid(scrollEl) {
        var cols = getColumnCount();
        var layout = waterfallColumnLayout(WATERFALL_ITEMS.length, cols);
        var colEls = [];
        var grid = document.createElement('div');
        grid.className = 'ugc-waterfall__cols';

        for (var c = 0; c < cols; c++) {
          var col = document.createElement('div');
          col.className = 'ugc-waterfall__col';
          colEls.push(col);
          grid.appendChild(col);
        }

        layout.forEach(function (indices, colIdx) {
          indices.forEach(function (itemIdx) {
            colEls[colIdx].appendChild(buildWaterfallItem(WATERFALL_ITEMS[itemIdx], itemIdx));
          });
        });

        scrollEl.innerHTML = '';
        scrollEl.appendChild(grid);
      }

      function initWaterfall() {
        var wrap = tabsRoot.querySelector('[data-waterfall]');
        var scrollEl = tabsRoot.querySelector('[data-waterfall-scroll]');
        if (!wrap || !scrollEl) return;

        renderWaterfallGrid(scrollEl);

        scrollEl.addEventListener('click', function (e) {
          var btn = e.target.closest('.ugc-waterfall__item');
          if (!btn) return;
          var idx = parseInt(btn.getAttribute('data-index'), 10);
          if (!isNaN(idx)) lightbox.open(WATERFALL_ITEMS, idx);
        });

        var autoSpeed = 0.55;
        var paused = false;
        var hovering = false;
        var rafId = null;
        var lastTs = 0;

        function canScrollInside() {
          return scrollEl.scrollHeight > scrollEl.clientHeight + 1;
        }

        function atBottom() {
          return scrollEl.scrollTop + scrollEl.clientHeight >= scrollEl.scrollHeight - 2;
        }

        function atTop() {
          return scrollEl.scrollTop <= 1;
        }

        function handleWaterfallWheel(e) {
          if (!highlightsPanelActive() || pauseWaterfallForLightbox) return;
          var dy = e.deltaY;
          if (!dy) return;
          if (!canScrollInside()) return;

          var down = dy > 0;
          var up = dy < 0;

          if ((down && atBottom()) || (up && atTop())) {
            e.preventDefault();
            e.stopPropagation();
            window.scrollBy(0, dy);
            return;
          }

          e.preventDefault();
          e.stopPropagation();
          scrollEl.scrollTop += dy;
        }

        function tick(ts) {
          rafId = requestAnimationFrame(tick);
          if (!highlightsPanelActive() || paused || hovering || pauseWaterfallForLightbox) {
            lastTs = ts;
            return;
          }
          if (atBottom()) {
            lastTs = ts;
            return;
          }
          var delta = lastTs ? ts - lastTs : 16;
          lastTs = ts;
          scrollEl.scrollTop += autoSpeed * (delta / 16);
        }

        function startAuto() {
          if (rafId) return;
          lastTs = 0;
          rafId = requestAnimationFrame(tick);
        }

        function stopAuto() {
          if (rafId) cancelAnimationFrame(rafId);
          rafId = null;
        }

        wrap.addEventListener('mouseenter', function () { hovering = true; });
        wrap.addEventListener('mouseleave', function () { hovering = false; });
        wrap.addEventListener('focusin', function () { hovering = true; });
        wrap.addEventListener('focusout', function (e) {
          if (!wrap.contains(e.relatedTarget)) hovering = false;
        });

        wrap.addEventListener('wheel', handleWaterfallWheel, { passive: false });

        var resizeTimer;
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {
            var pos = scrollEl.scrollTop;
            renderWaterfallGrid(scrollEl);
            scrollEl.scrollTop = Math.min(pos, scrollEl.scrollHeight);
          }, 150);
        });

        startAuto();

        document.addEventListener('visibilitychange', function () {
          paused = document.hidden;
        });
      }

      function initFeaturedCarousel() {
        var root = tabsRoot.querySelector('[data-featured-carousel]');
        var track = tabsRoot.querySelector('[data-featured-track]');
        var prevBtn = tabsRoot.querySelector('[data-featured-prev]');
        var nextBtn = tabsRoot.querySelector('[data-featured-next]');
        if (!root || !track) return;

        var active = 0;
        var cards = [];
        var timer = null;
        var hovering = false;

        FEATURED_ITEMS.forEach(function (item, i) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'ugc-featured__card';
          btn.setAttribute('data-index', String(i));
          btn.innerHTML =
            '<span class="ugc-featured__media"><img src="' + featuredCardSrc(item) + '" alt="Featured entry ' + item.id + '" loading="lazy"></span>' +
            (item.badge ? '<span class="ugc-featured__badge">' + item.badge + '</span>' : '');
          btn.addEventListener('click', function () {
            lightbox.open(FEATURED_ITEMS, i);
          });
          track.appendChild(btn);
          cards.push(btn);
        });

        function updateFeaturedImages() {
          cards.forEach(function (card, i) {
            var img = card.querySelector('img');
            if (img) img.src = featuredCardSrc(FEATURED_ITEMS[i]);
          });
        }

        function layout() {
          var total = cards.length;
          var isMob = !isFeaturedPcLayout();
          var maxVisible = isMob ? 3 : 2;
          var spreadPx = featuredSpreadPx(isMob);
          var maxRot = featuredMaxRot(isMob);
          var scaleStep = isMob ? 0.04 : 0.06;
          var scaleMin = isMob ? 0.88 : 0.82;
          var opacityStep = isMob ? 0.07 : 0.15;
          var opacityMin = isMob ? 0.72 : 0.45;

          cards.forEach(function (card, i) {
            var offset = i - active;
            if (offset > total / 2) offset -= total;
            if (offset < -total / 2) offset += total;

            var abs = Math.abs(offset);
            if (abs > maxVisible) {
              card.classList.add('is-hidden');
              card.classList.remove('is-back');
              card.style.zIndex = '0';
              card.style.transform = 'translate(-50%, -50%) scale(0.5)';
              card.style.opacity = '0';
              return;
            }

            card.classList.remove('is-hidden');
            card.classList.toggle('is-back', offset !== 0);
            var tx = offset * spreadPx;
            var rot = offset * maxRot;
            var scale = offset === 0 ? 1 : Math.max(scaleMin, 1 - abs * scaleStep);
            var scaleY = offset === 0 ? 1 : scale * Math.max(0.85, 1 - abs * 0.1);
            var opacity = offset === 0 ? 1 : Math.max(opacityMin, 1 - abs * opacityStep);

            card.style.zIndex = String(10 - abs);
            card.style.opacity = String(opacity);
            card.style.transform = offset === 0
              ? 'translate(calc(-50% + ' + tx + 'px), -50%) rotate(' + rot + 'deg) scale(1)'
              : 'translate(calc(-50% + ' + tx + 'px), -50%) rotate(' + rot + 'deg) scale(' + scale + ', ' + scaleY + ')';
          });
        }

        function go(step) {
          active = (active + step + cards.length) % cards.length;
          layout();
          resetTimer();
        }

        function resetTimer() {
          if (timer) clearInterval(timer);
          timer = setInterval(function () {
            if (!highlightsPanelActive() || hovering) return;
            go(1);
          }, 4500);
        }

        if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });

        root.addEventListener('mouseenter', function () { hovering = true; });
        root.addEventListener('mouseleave', function () { hovering = false; });

        root.addEventListener('wheel', function (e) {
          if (!highlightsPanelActive()) return;
          e.preventDefault();
          if (e.deltaY > 0 || e.deltaX > 0) go(1);
          else go(-1);
        }, { passive: false });

        var featResizeTimer;
        window.addEventListener('resize', function () {
          clearTimeout(featResizeTimer);
          featResizeTimer = setTimeout(function () {
            updateFeaturedImages();
            layout();
          }, 150);
        });

        layout();
        resetTimer();
      }

      initWaterfall();
      initFeaturedCarousel();
    })();